import { render, staticRenderFns } from "./BindingMobile.vue?vue&type=template&id=55d111a8&scoped=true"
import script from "./BindingMobile.vue?vue&type=script&lang=js"
export * from "./BindingMobile.vue?vue&type=script&lang=js"
import style0 from "./BindingMobile.vue?vue&type=style&index=0&id=55d111a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d111a8",
  null
  
)

export default component.exports